import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_clientes/Administracion_clientes.html?vue&type=template&id=925a6d5e&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_clientes/Administracion_clientes.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_clientes/Administracion_clientes.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_clientes/Administracion_clientes.css?vue&type=style&index=0&id=925a6d5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925a6d5e",
  null
  
)

export default component.exports